var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subheading-wrapper"},[_c('div',{staticClass:"subheading"},[_c('cms-text',{attrs:{"value":`${_vm.prefix}.grid_heading`}})],1),_c('div',{staticClass:"subheading"},[_c('cms-text',{attrs:{"value":`${_vm.prefix}.grid_subheading`}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }